import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=d03bf126&"
import script from "./Standard.vue?vue&type=script&lang=ts&"
export * from "./Standard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports